import throttle from 'lodash/throttle.js';
/**
 * Try to JSON-parse a string, return null on failure.
 */
function maybeParse(str) {
    try {
        return JSON.parse(str);
    }
    catch {
        return null;
    }
}
const prefix = 'uppyState:';
const getItemKey = (name) => `${prefix}${name}`;
function expireOldState() {
    const existingKeys = [];
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key?.startsWith(prefix)) {
            existingKeys.push(key);
        }
    }
    const now = Date.now();
    existingKeys.forEach((key) => {
        const data = localStorage.getItem(key);
        if (!data)
            return;
        const obj = maybeParse(data);
        if (obj?.expires && obj.expires < now) {
            localStorage.removeItem(key);
        }
    });
}
export default class MetaDataStore {
    opts;
    name;
    // biome doesn't seem to support #fields
    #saveThrottled;
    constructor(opts) {
        this.opts = {
            expires: 24 * 60 * 60 * 1000, // 24 hours
            throttleTime: 500,
            ...opts,
        };
        this.name = getItemKey(opts.storeName);
        this.#saveThrottled =
            this.opts.throttleTime === 0
                ? this.save
                : throttle(this.save, this.opts.throttleTime, {
                    leading: true,
                    trailing: true,
                });
    }
    #state;
    /**
     *
     */
    load = () => {
        expireOldState();
        const savedState = localStorage.getItem(this.name);
        if (!savedState)
            return undefined;
        const data = maybeParse(savedState);
        if (!data)
            return undefined;
        this.#state = data;
        return data.metadata;
    };
    get = () => {
        return this.#state?.metadata;
    };
    save = () => {
        if (this.#state === null) {
            localStorage.removeItem(this.name);
            return;
        }
        const state = JSON.stringify(this.#state);
        localStorage.setItem(this.name, state);
    };
    /**
     * Save the given metadata to localStorage, along with an expiry timestamp.
     * If metadata is null, remove any existing stored state.
     *
     * @param metadata - The metadata to store, or null to clear the stored state.
     */
    set = (metadata) => {
        this.#state =
            metadata === null
                ? null
                : {
                    metadata,
                    expires: Date.now() + this.opts.expires,
                };
        this.#saveThrottled();
    };
}
